export interface CallRecordingAgent {
  agentId: string;
  agentLogin: string;
  agentOwner: string;
}

export interface ContactData {
  errors?: ContactError[];
  contact?: Contact;
}

export type ContactError = {
  message: string;
  extensions: ContactErrorExtensions;
};

type ContactErrorExtensions = {
  classification: string;
  code: string;
  exception: ContactExtensionException;
};

type ContactExtensionException = {
  stacktrace: string[];
};

export type Contact = {
  medium: ContactMedium;
  owner: CSAgent;
  dartEscalationContactList?: Contact[];
  contactTimeline?: ContactTimeline;
};

type CSAgent = {
  agentId: string;
  agentLogin: string;
  agentOwner?: string;
};

type ContactMedium = {
  type?: ContactMediumType;
  chat?: Chat;
  connectPhoneRecordList?: ConnectPhoneRecord[];
  emailBodyRedacted?: string;
  emailSubjectRedacted?: string;
};

export enum ContactMediumType {
  MAIL = 'MAIL',
  EMAIL = 'EMAIL',
  CHAT = 'CHAT',
  PHONE = 'PHONE',
}

type CallRecordingPart = {
  base64?: String;
  nextPart?: String;
};

export enum ContactListeningQueryTypeOption {
  COMPLETE = 'COMPLETE',
  CONNECT_PART = 'CONNECT_PART',
  DART_CONNECT_PART = 'DART_CONNECT_PART',
}

type ContactTimeline = {
  contactTimelineEvents: ContactTimelineEvent[];
};

type TranslatedMessage = {
  stringId?: string;
  values?: Record<string, string>;
};

export type ContactTimelineEvent = {
  agent?: CSAgent;
  message: string;
  date: string;
  eventType: EventType;
  translatedMessage?: TranslatedMessage;
};

export enum EventType {
  STATE_TRANSITION = 'STATE_TRANSITION',
  AUTO_ANNOTATION = 'AUTO_ANNOTATION',
  AGENT_ANNOTATION = 'AGENT_ANNOTATION',
}

export type ConnectPhoneRecord = {
  connectContactId?: string;
  presignedUrl: string;
  agent?: CSAgent;
  callRecordingPart?: CallRecordingPart;
};

export type Chat = {
  messages?: ChatMessage[];
};

export type ChatMessage = {
  type: ChatMessageType;
  timestamp: string;
  chatText: ChatText;
  translationList?: ChatText[];
  participant?: ChatParticipant;
  stateChangeType: ChatParticipantStateChangeType;
  disconnectReason?: ChatDisconnectReason;
};

export interface ChatParticipant {
  __typename: ChatParticipantType;
  name?: string;
  customerName?: string;
  preferredLanguage: string;
}

export enum ChatParticipantType {
  CUSTOMER = 'CustomerChatParticipant',
  CSA = 'CSAChatParticipant',
  BOT = 'BotChatParticipant',
}

type ChatText = {
  text: string;
  language: string;
};

export enum ChatMessageType {
  MESSAGE = 'MESSAGE',
  CHAT_TRANSFERRED = 'CHAT_TRANSFERRED',
  CHAT_PARKED = 'CHAT_PARKED',
  PARTICIPANT_CHANGE = 'PARTICIPANT_CHANGE',
}

export enum ChatParticipantStateChangeType {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  ON_HOLD = 'ON_HOLD',
  OFF_HOLD = 'OFF_HOLD',
}

export const defaultContactData: ContactData = {
  errors: undefined,
  contact: undefined,
};

export enum ChatDisconnectReason {
  PUSH_SERVICE_ERROR = 'PUSH_SERVICE_ERROR',
  MESSAGE_TRANSPORT_ERROR = 'MESSAGE_TRANSPORT_ERROR',
  USER_HANGUP = 'USER_HANGUP',
  AGENT_HUNGUP = 'AGENT_HUNGUP',
  AGENT_PARTICIPANT_CHANGE_TIMEOUT = 'AGENT_PARTICIPANT_CHANGE_TIMEOUT',
  KEEP_ALIVE_TIMEOUT = 'KEEP_ALIVE_TIMEOUT',
  GACD_HANGUP = 'GACD_HANGUP',
  DISCONNECT = 'DISCONNECT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  AGENT_PARKED = 'AGENT_PARKED',
  BOT_GAVEUP = 'BOT_GAVEUP',
  BOT_PARKED = 'BOT_PARKED',
  BOT_DISCONNECT = 'BOT_DISCONNECT',
  OVER_CAPACITY = 'OVER_CAPACITY',
  ATTRIBUTES_LIMIT_EXCEEDED = 'ATTRIBUTES_LIMIT_EXCEEDED',
}
